import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { LOCATION_API } from "./apiRoutes";

interface UseGetCityListByStateProps {
  stateId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}
const getCityListByState = async (stateId: string) => {
  return await axiosAuth.get(`${LOCATION_API}/states/${stateId}/cities`);
};

const useGetCityListByState = ({
  stateId,
  queryParams,
}: UseGetCityListByStateProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["city-list", stateId],
    queryFn: () => getCityListByState(stateId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetCityListByState;
